import { Flex, ContentWrapper, Text, TextVariant } from '@mprolab/uikit'
import React from 'react'
import styled from 'styled-components'

const MainWrapper = styled(Flex)`
  flex-direction: column;
  padding: 64px 0;
`

const PrivacyPolicy: React.FC = () => {
  return (
    <Flex justifyContent="center">
      <ContentWrapper>
        <MainWrapper mt="82px">
          <Text variant={TextVariant.H4} mb="16px">
            Privacy Policy
          </Text>
          <Text variant={TextVariant.BODY_DEFAULT}>
            The full Privacy Policy for MPRO Lab is being published. Please contact support@mprolab.io if you require
            the current document.
          </Text>
        </MainWrapper>
      </ContentWrapper>
    </Flex>
  )
}

export default PrivacyPolicy
